import Request from "shared/Request";

export const setMe = user => {
  return {
    type: "SET_ME",
    payload: user
  };
};

export const loadMe = () => {
  return Request.get("me");
};
